import {
    SET_SYSTEM_PRODUCTION,
    SET_SYSTEM_PRICE,
} from './constants';

export const setSystemProduction = systemProduction => ({
    type: SET_SYSTEM_PRODUCTION,
    systemProduction,
});


export const setSystemPrice = cashprice => ({
    type: SET_SYSTEM_PRICE,
    cashprice,
});



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/actions.js